<template>
  <div class="step-number">
    <div class="step-number__number">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ width: string }>();

const stepWidth = computed(() => {
  return props.width || "16px";
});
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";
.step-number {
  width: v-bind(stepWidth);
  height: v-bind(stepWidth);
  border-radius: 100vmax;
  background-color: @charismatic-color;
  display: flex;
  justify-content: center;
  align-items: center;

  &__number {
    color: #ffffff;
    font-weight: bold;
  }
}
</style>
